export default ({ actions }) =>
  <div className="my-2 article-width">

    <h4>Test</h4>

    <button className="btn btn-primary" onClick={e => {
      // TODO: Send test request
      console.log('Test')
      actions.sendTriageRequest({
        action: 'test'
      })
    }}>Go</button>
  </div>
